import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { replace } from 'react-router-redux';

import { storeRedirectValues } from 'actions/redirect';
import { triggerHardRedirect } from 'actions/window';
import { routes } from 'config/routes';
import { mapPropsFromRoute } from 'utils/routeHelpers';

import RedirectingPage from 'components/common/RedirectingPage';

export class ExternalRedirect extends Component {
  componentWillMount() {
    const {
      dispatchReplace,
      dispatchStoreRedirectValues,
      dispatchTriggerHardRedirect,
      location,
      dispatch,
      redirectUrl,
      onRedirectAction,
    } = this.props;

    // follow-up action if you've used an action creator in your
    if (typeof onRedirectAction === 'function') {
      dispatch(onRedirectAction());
    }

    // TODO figure out a way to store the previous path here
    dispatchStoreRedirectValues({
      url: '/',
      preserveUrlParams: false,
    });

    // dispatch a silent replace
    dispatchReplace({
      pathname: routes.REDIRECT,
      state: location.state,
    });

    // hard redirect to the real path.
    dispatchTriggerHardRedirect(redirectUrl);
  }

  render() {
    return <RedirectingPage />;
  }
}

ExternalRedirect.defaultProps = {
  route: {},
};

ExternalRedirect.propTypes = {
  dispatch: PropTypes.func.isRequired,
  dispatchReplace: PropTypes.func.isRequired,
  dispatchStoreRedirectValues: PropTypes.func.isRequired,
  dispatchTriggerHardRedirect: PropTypes.func.isRequired,
  redirectUrl: PropTypes.string.isRequired,
  onRedirectAction: PropTypes.func,
  route: PropTypes.object,
  location: PropTypes.shape({
    state: PropTypes.string.isRequired,
  }).isRequired,
};

export default compose(
  connect(null, dispatch => ({
    dispatch,
    ...bindActionCreators({
      dispatchReplace: replace,
      dispatchStoreRedirectValues: storeRedirectValues,
      dispatchTriggerHardRedirect: triggerHardRedirect,
    }, dispatch),
  })),

  // guarantees location will be present
  withRouter,

  // pull props off of the route to the main props.
  // this makes the component embeddable more easily.
  withProps(props => mapPropsFromRoute(props, ['redirectUrl', 'onRedirectAction'])),
)(ExternalRedirect);



// WEBPACK FOOTER //
// ./src/components/Redirects/ExternalRedirect.js